import { useMutation } from 'react-query';

import { createUser as mutationFn } from 'api/endPoints/createUser';

export const useMutationCreateUser = () => {
    return useMutation<unknown, QueryError, unknown>('createUser', (params) => mutationFn(params));
};
